import React from "react";
import { WifiOff } from "lucide-react";

// Estado vacío mostrado en pantallas que requieren conexión (IA, backups,
// exportación, usuarios). Evita que la pantalla rompa cuando no hay señal.
export function OfflineNotice({ label }) {
  return (
    <div
      data-testid="offline-notice"
      className="rounded-[var(--radius)] border border-dashed border-border bg-muted/40 p-8 text-center"
    >
      <WifiOff size={28} className="text-muted-foreground mx-auto mb-2" />
      <h3 className="font-heading font-semibold text-[15px]">Esta función necesita internet</h3>
      <p className="text-[13px] text-muted-foreground mt-1 max-w-sm mx-auto">
        {label || "Conectate a internet para usar esta sección."} Volvé a intentarlo cuando vuelva la señal.
      </p>
    </div>
  );
}
